import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { emailService } from './emailService';


const getPromoCodeFromURL = () => {
  // Intentar obtener de sessionStorage primero (si viene de redirección)
  const storedPromo = sessionStorage.getItem('promo_code');
  if (storedPromo) {
    return storedPromo;
  }
  
  // Si no, intentar obtener de la URL actual
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('promo') || null;
};

const getTrackingParams = () => {
  const tracking = {
    promo_code: null,
    source: null
  };
  
  // Intentar obtener de sessionStorage primero (si viene de redirección)
  const storedPromo = sessionStorage.getItem('promo_code');
  const storedSource = sessionStorage.getItem('tracking_source');
  
  if (storedPromo) {
    tracking.promo_code = storedPromo;
  }
  
  if (storedSource) {
    tracking.source = storedSource;
  }
  
  // Si no hay datos en sessionStorage, intentar obtener de la URL actual
  const urlParams = new URLSearchParams(window.location.search);
  const urlPromo = urlParams.get('promo');
  const urlSource = urlParams.get('source') || urlParams.get('utm_source'); // También compatible con utm_source
  
  if (urlPromo && !tracking.promo_code) {
    tracking.promo_code = urlPromo;
  }
  
  if (urlSource && !tracking.source) {
    tracking.source = urlSource;
  }
  
  return tracking;
};

export const RESERVATION_TYPES = {
  NORMAL: 'normal',
  WAITLIST: 'waitlist',
  GROUP: 'group'
};

export const RESERVATION_STATUS = {
  PENDING: 'PENDIENTE DE CONFIRMACION',
  PENDING_REVIEW: 'PENDIENTE DE GESTION',
  CONFIRMED: 'RESERVA CONFIRMADA',
  CANCELLED: 'RESERVA CANCELADA',
  SEATED: 'SENTADA',
  ARRIVED: 'LLEGADA',
  RELEASED: 'LIBERADA',
  NO_SHOW: 'NO SHOW'
};

export const createReservation = async (reservationData, source = 'web', type = RESERVATION_TYPES.NORMAL) => {
  try {
    // Obtener parámetros de tracking
    const trackingParams = getTrackingParams();
    
    // El source de tracking tiene prioridad sobre el source por defecto
    const finalSource = trackingParams.source || source;
    
    const status = type === RESERVATION_TYPES.NORMAL
      ? RESERVATION_STATUS.CONFIRMED
      : RESERVATION_STATUS.PENDING_REVIEW;
    
    // Crear la reserva con código promocional y source
    const reservationToCreate = {
      ...reservationData,
      source: finalSource, // Usar el source del tracking o el default
      codigo_promo: trackingParams.promo_code, // Código promocional si existe
      status: status,
      reservationType: type,
      createdAt: serverTimestamp(),
      confirmedAt: type === RESERVATION_TYPES.NORMAL ? serverTimestamp() : null
    };
    
    const docRef = await addDoc(collection(db, 'reservations'), reservationToCreate);
    const reservationId = docRef.id;
    
    // Limpiar los datos de tracking después de usarlos
    if (trackingParams.promo_code || trackingParams.source) {
      sessionStorage.removeItem('promo_code');
      sessionStorage.removeItem('tracking_source');
      console.log(`Reserva creada - Promo: ${trackingParams.promo_code}, Source: ${finalSource}`);
    }
    
    // Enviar correos de confirmación solo para reservas normales
    if (type === RESERVATION_TYPES.NORMAL) {
      try {
        // Usar el servicio de email existente para enviar confirmaciones
        await emailService.sendReservationStatusEmail(
          {
            ...reservationToCreate,
            id: reservationId // Añadir el ID generado
          },
          RESERVATION_STATUS.CONFIRMED
        );
        
        console.log('Emails de confirmación enviados correctamente');
      } catch (emailError) {
        console.error('Error al enviar emails de confirmación:', emailError);
        // El error en el envío de emails no debería impedir la creación de la reserva
      }
    }
    
    return reservationId;
  } catch (error) {
    console.error('Error en el proceso de reserva:', error);
    throw new Error(`Error al crear la reserva: ${error.message}`);
  }
};

// Función para solicitudes especiales (sin cambios sustanciales)
export const createSpecialReservation = async (reservationData, type, source = 'web') => {
  try {
    // Obtener código promocional si existe
    const trackingParams = getTrackingParams();
    
    const specialReservationData = {
      ...reservationData,
      tables: [],
      codigo_promo: trackingParams.promo_code,
      source: trackingParams.source
    };
    
    const reservationId = await createReservation(specialReservationData, trackingParams.source, type);
    
    // Enviar email de notificación para solicitud especial
    try {
      await emailService.sendSpecialReservationEmail(
        {
          ...specialReservationData,
          id: reservationId
        },
        type
      );
      
      console.log('Emails de solicitud especial enviados correctamente');
    } catch (emailError) {
      console.error('Error al enviar emails de solicitud especial:', emailError);
    }
    
    return reservationId;
  } catch (error) {
    console.error('Error en la solicitud especial:', error);
    throw error;
  }
};